import { FormsModule } from "@angular/forms";

import { LoginComponent } from "./login.component";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { environment } from "../../environments/environment";

import { Routes } from "@angular/router";
import { RouterModule } from "@angular/router";
import { SmsVerificationModalComponent } from "../dashboard/main/common/modals/sms-verification-modal.component";
import { BsModalRef, BsModalService, ModalModule } from "ngx-bootstrap/modal";
import { ConversationsService } from "../dashboard/conversations/conversations.service";
import { MyAccountService } from "../dashboard/main/common/modals/my-account-modal.service";

const routes: Routes = [{ path: "", component: LoginComponent }];

@NgModule({
    imports: [CommonModule, RouterModule.forChild(routes), FormsModule, LoginComponent],
    providers: [
        BsModalRef,
        BsModalService,
        ConversationsService,
        MyAccountService,
    ],
})
export class LoginModule {}
